// noinspection SpellCheckingInspection

import React from 'react';
import styles from './Instructions.module.css';
import newReservationScreenshot from '../../assets/images/new_reservation.png'
import addedScreenshot from '../../assets/images/added.png'
import viewReservationsScreenshot from '../../assets/images/view_reservations.png'
import paymentScreenshot from '../../assets/images/payment.png'
import periodicPay1Screenshot from '../../assets/images/periodicPay1.png'
import periodicPay2Screensho from '../../assets/images/periodicPay2.png'
import redirectToMemberFeeButtonScreenshot from '../../assets/images/redirectToMemberFeeButton.png'
import memberFeeFormScreenshot from '../../assets/images/memberFeeForm.png'
import memberFeePaydScreenshot from '../../assets/images/memberFeePayd.png'

const Instructions = () => {
    // noinspection JSValidateTypes
    return (
        <div className={styles.instructionsContainer}>
            <div className={styles.instructionText}>
                <h5>1. Rejestracja</h5>
                <p>Korzystanie z systemu rezerwacji wymaga założenia konta.
                    Kliknij w link "Rejestracja", wypełnij wymagane dane i postępuj zgodnie z instrukcjami.
                    Jeżeli w procesie rejestracji podałeś prawidłowy adres e-mail, w ciągu kilku sekund na Twojej
                    skrzynce mailowej
                    pojawi się wiadomość z linkiem aktywacyjnym.
                    Należy w niego kliknąć aby dokończyć proces zakładania nowego konta. Link jest ważny 20
                    minut, więc nie należy odkładać tej czynności na później.</p>
            </div>
            <div className={styles.instructionText}>
                <h5>2. Dodanie nowej rezerwacji</h5>
                <div className={styles.imageContainer}>
                    <img src={newReservationScreenshot} alt="Rezerwacja" className={styles.floatingImageLeft}/>
                    <p>Po zalogowaniu się, jeżeli nie masz zaległych płatności nastąpi przekierowanie na grafik
                        rezerwacji.
                        Obce rezerwacje są oznaczone kolorem czerwonym. Jasne komórki to niezajęte przez nikogo godziny.
                        Należy klikać
                        w wybrane komórki a na ekranie pojawi się projekcja planowanej rezerwacji (kolor niebieski).
                        Dla osób nie posiadających członkowstwa BTT dodatkowo będzie prezentowany koszt
                        planowanej rezerwacji. Do momentu kliknięcia w przycisk 'Rezerwuj' można modyfikować planowana
                        rezerwacje.</p>
                </div>
                <div className={styles.imageContainer}>
                    <img src={addedScreenshot} alt="rezerwacja dodana" className={styles.floatingImageRight}/>
                    <p>Po kliknięciu w przycisk 'Rezerwuj' jeżeli nie pojawią się żadne przeszkody (np. przeterminowane płatności)
                        to oznaczone na niebiesko komórki zmienią kolor na zielony
                        (tym kolorem są zazanczone własne rezerwacje).</p>
                </div>
            </div>
            <div className={styles.instructionText}>
                <h5>3. Anulowanie rezerwacji </h5>
                <div className={styles.imageContainer}>
                    <img src={viewReservationsScreenshot} alt="przegląd rezerwacji"
                         className={styles.floatingImageLeft}/>
                    <p>Wykonane rezerwacje można przeglądać bezpośrednio na grafiku (oznaczone są one kolorem zielonym)
                        lub
                        w 'Moje Dane' w zakładce REZERWACJE, gdzie prezentowane są wszystkie zaplanowane i
                        archiwalne rezerwacje.
                        Do momentu rozpoczęcia czasu zaplanowanej rezerwacji można ją anulowąć klikacjąc w znak 'X'.
                        Rezerwacje można też anulować bezpośrednio na grafiku, klikając w zielone komórki. Anulowane
                        rezerwacje powodują, że zajęte wcześnej komórki znów są dostępne. <br/><b>Uwaga!</b> Każda rezerwacja ze względów technicznych
                        może być anulowana przez Administratora,
                        dlatego przed przyjściem na korty, należy sprawdzić czy rezerwacja jest nadal aktualna.</p>
                </div>
            </div>
            <div className={styles.instructionText}>
                <h5>4. Płatności </h5>
                <div className={styles.imageContainer}>
                    <img src={paymentScreenshot} alt="płatności" className={styles.floatingImageRight}/>
                    <p>W momencie gdy mija data startu rezerwacji, pojawia się ona w 'Moje Dane' w zakładce
                        'PŁATNOŚCI'. Takiej rezerwacji nie można już anulować.
                        Powstaje obowiązek zapłaty bez względu na to czy rezerwacja została wykorzystana czy też nie.
                        Przycisk
                        'Płacę' przenosi do bramki płatności, gdzie za pomocą jednej z wielu metod (np. BLIK) można
                        regulować należności.
                        Jeżeli proces płatności przebiegnie prawidłowo, opłacona rezerwacja znika z listy nieopłaconych
                        rezerwacji.</p>
                </div>
                <div className={styles.imageContainer}>
                    <img src={periodicPay1Screenshot} alt="płatność okresowa 1" className={styles.floatingImageLeft}/>
                    <p>W sytuacji gdy właściciel konta nie posiada żadnych zaległych płatności pojawia się możliwość
                        wniesienia opłaty okresowej.
                        Do wyboru dostępny jest okres 7, 14 lub 30 dni wynajmu kortu (2 godziny dziennie).</p>
                </div>
                <div className={styles.imageContainer}>
                    <img src={periodicPay2Screensho} alt="Platnosc okresowa 2" className={styles.floatingImageRight}/>
                    <p>Po zakończeniu procesu płatności, w zakładce 'PŁATNOŚCI'
                        widoczna jest data, do której można rezerwować korty w ramach opłaty okresowej.
                        Data ważności opłaty okresowej jest automatycznie przedłużana o każdy dzień niedostępności
                        kortów.</p>
                </div>
            </div>
            <div className={styles.instructionText}>
                <h5>5. Składki członkowskie </h5>

                <div className={styles.imageContainer}>
                    <img src={redirectToMemberFeeButtonScreenshot} alt="button" className={styles.floatingImageLeft}/>
                    <p> W zakładce 'PŁATNOŚCI' w dolnej części ekranu znajduje się przycisk 'Chcę opłacić składkę BTT'.
                        Kliknięcie w niego przenosi do formularza opłacenia składki członkowskiej. Użytkownik, który przed opłaceniem
                        składki członkowskiej posiadał rezerwacje do opłacenia (status "REG"), to momencie opłacenia składki członkowskiej
                        rezerwacje te zmienią status na "MEM", co oznacza urugulowanie wcześniejszym zobowiązań.
                    </p>
                </div>
                <div className={styles.imageContainer}>
                    <img src={memberFeeFormScreenshot} alt="formularz składki BTT" className={styles.floatingImageLeft}/>
                    <p>Należy wybrać jedną z dostępnych opcji. Opłacenie składki członkowskiej wiąże się z
                        przynależnością
                        do Bocheńskiego Towarzystwa Tenisowego, którego podstawią działania jest Statut BTT. Po
                        akceptacji Statutu można przystąpić do zainicjowania płatności poprzez kliknięcie w przycisk 'Płacę'.</p>
                </div>
                <div className={styles.imageContainer}>
                    <img src={memberFeePaydScreenshot} alt="opłacona składka btt" className={styles.floatingImageRight}/>
                    <p>Pozytywnie przeprowadzony proces opłacenia składki BTT powinien skutkować pojawieniem się w zakładce 'PŁATNOŚCI'
                    informacji 'Masz opłaconą składkę BTT'. Odtąd wykonane rezerwacje nie będą obciążane kosztami wynajmu kortu.<br/> <b>Jednak
                    w przypadku</b>, gdy w grze biorą udział osoby nie będące członkami BTT, wtedy taka rezerwacja powinna być oznaczona checkBox-em
                        'Gracze spoza BTT '. W takim przypadku naliczona zostanie opłata w wysokości 40% stawki godzinowej. </p>
                </div>
            </div>


            <div className={styles.instructionText}>
                <h5>6. Statusy rezerwacji </h5>

                <div className={styles.imageContainer}>
                    <span> <b>REG</b> - rezerwacja zarejestrowana (do zapłaty), <br/>
                        <b>PAY</b> - rezerwacja opłacona, <br/>
                        <b>PER</b> - rezerwacja w ramach opłaty okresowej, <br/>
                        <b>CAN</b> - rezerwacja anulowana (brak obowiązku zapłaty), <br/>
                        <b>MEM</b> - rezerwacja w ramach składki członkowskiej BTT, <br/>
                        <b>NME</b> - rezerwacja z dopłatą za gracza spoza BTT (do zapłaty).
                    </span>
                </div>
            </div>

        </div>


    );
};

export default Instructions;